import React from "react";
import { UserMenuModule } from "./userMenuModule";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";

export let userMenuStore;

export function createStore() {
  userMenuStore = createReduxStore("userMenu");
  return userMenuStore;
}

function UserMenu(props) {
  return (
    <Provider store={createStore()}>
      <UserMenuModule userParams={props} currentUser={props.currentUser} />
    </Provider>
  );
}

export default UserMenu;
